import { useNavigate } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import "./DockingMate.css";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DockingmateHero from "../../../assets/dockingmate-login.jpeg";
import DockingmateAbout from "../../../assets/dockingmate-easy-rent-swap.jpg";
import SwappingYourBerth from "../../../assets/Swapping-your-berth.jpeg";
import HowitWorks from "../../../assets/dockingmate-how-it-works.png";
import GreenmateAbout from "../../../assets/greenmate-about.jpg";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { MooringMateHomeHeader } from "../../../components/HomeHeader/MooringMateHomeHeader";
import { GeneralFooter, MooringmateFAQ, LanguageDropdown, BerthMap } from "../../../components";
// import { LanguageDropdown } from "../../../components/Dropdown/LanguageDropdown";

export const DockingMate = (props) => {
  const navigate = useNavigate();
  const [selectedLang, setSelectedLang] = useState("en");

  const languages = useMemo(() => ([
    {
      code: "en",
      label: "English",
      flag: "https://flagcdn.com/w40/us.png",
    },
    {
      code: "es",
      label: "Spanish",
      flag: "https://flagcdn.com/w40/es.png",
    },
    {
      code: "fr",
      label: "French",
      flag: "https://flagcdn.com/w40/fr.png",
    },
    {
      code: "nl",
      label: "Dutch",
      flag: "https://flagcdn.com/w40/nl.png",
    },
  ]), []);

  useEffect(() => {
    // Handle navigation to faq from any page
    if (document.location.hash === "#faq") {
      const faqSection = document.getElementById("faq");
      if (faqSection) {
        if (faqSection.classList.contains("hideFaq")) {
          faqSection.classList.remove("hideFaq");
        }

        faqSection.classList.add("showFaq");
        faqSection.scrollIntoView({ behavior: "smooth" });
      }
    }

    // Clean up function
    return () => {
      const faqSection = document.getElementById("faq");
      if (faqSection) {
        if (faqSection.classList.contains("showFaq"))
          faqSection.classList.remove("showFaq");
        
        faqSection.classList.add("hideFaq");
      }
    }
  }, [])

  useEffect(() => {
    // Hide all language contents first
    languages.forEach((lang) => {
      const elements = document.querySelectorAll(`[data-lang="${lang.code}"]`);
      elements.forEach((el) => {
        el.style.display = lang.code === selectedLang ? "block" : "none";
      });
    });
  }, [selectedLang, languages]);

  return (
    <Box>
      {/* <CssBaseline /> */}
      <MooringMateHomeHeader />
      <Box
        component="main"
        className="hero-section inner"
        style={{ backgroundImage: `url(${DockingmateHero})` }}
      >
        <Box className="hero-overlay">
          <Container maxWidth="lg">
            <Grid container spacing={2} columns={12}>
              <Grid item md={12} sm={12} xs={12}>
                <div className="hero-content">
                  <h1 style={{ color: "white" }}>Mooring made easy</h1>
                  <h4>Your ultimate docking solution</h4>
                  <Button
                    onClick={() => navigate("/login")}
                    sx={{
                      backgroundColor: "#4CAF50",
                      color: "white",
                      border: "none",
                      fontWeight: "600",
                      borderRadius: "4px",
                      cursor: "pointer",
                      transition: "background-color 0.3s ease",
                      padding: { xs: "10px 24px", md: "12px 32px", lg: "12px 36px" },
                      fontSize: { xs: "11px", lg: "15px" },
                      width: { xs: "100%", sm: "auto" },
                      maxWidth: { xs: "280px", sm: "none" },
                      "&:hover": {
                        backgroundColor: "#45a049"
                      }
                    }}
                  >
                    Get Started
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>

      {/* Live Berths Map Section */}
      <Box sx={{ py: 6 }}>
        <Box sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <h2 className="title">Available Berths Worldwide</h2>
            <p style={{ color: "#666", fontSize: "16px" }}>
              Explore available berths around the world. Search for locations and discover mooring opportunities.
            </p>
          </Box>
          <BerthMap />
        </Box>
      </Box>

      <Box>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            sx={{
              alignItems: "center",
            }}
            style={{ paddingTop: "100px", paddingBottom: "40px" }}
          >
            <Grid item md={6}>
              <h6 className="sub-title">How does it work?</h6>
              <h2 className="title">
                Easily Rent or swap a Mooring for Your Boat
              </h2>
              <div className="section-content">
                <p style={{ marginBottom: '20px' }}>Looking for a mooring for your boat? Or do you have a mooring spot you'd like to rent out? Our platform makes the process simple, transparent, and efficient.</p>
                {/* <Link href="#contact">Get in touch</Link> */}
              </div>
            </Grid>
            <Grid item md={6}>
              <img className="heroImage" alt="" src={DockingmateAbout} />
            </Grid>
          </Grid>
        </Container>
      </Box>
      
      <Box>
        <Container maxWidth="lg">
          <Grid
            id="services"
            className="empowering"
            container
            spacing={2}
            style={{ paddingTop: "40px", paddingBottom: "40px" }}
          >
            <Grid item md={12}>
              {/* <h6 className="sub-title">Fuel connections</h6> */}
              <h2 className="title">
                Mooringmate - Enabling sustainable mooring and mobility
              </h2>
            </Grid>
            <Grid item md={4} sm={6}>
              <Card className="blog-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div
                    className="blog-thumb"
                    style={{ backgroundImage: `url(${GreenmateAbout})` }}
                  ></div>
                  <h3>
                    Berth rentals <ChevronRightIcon />
                  </h3>
                  <p>Turn your mooring into income Have an available berth? List it in just a few steps, set your price, and start renting it out. Mooringmate helps you maximise the value of your mooring while contributing to a more sustainable yachting community.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6}>
              <Card className="blog-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div
                    className="blog-thumb"
                    style={{ backgroundImage: `url(${SwappingYourBerth})` }}
                  ></div>
                  <h3>
                    Swapping your berth
                    <ChevronRightIcon />
                  </h3>
                  <p>Explore more, without extra mooring costs Easily swap your berth with other yacht owners through Mooringmate. Discover new destinations while keeping your costs low. Our secure and user-friendly platform gives you the flexibility to enjoy more time on the water.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6}>
              <Card className="blog-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div
                    className="blog-thumb"
                    style={{ backgroundImage: `url(${HowitWorks})` }}
                  ></div>
                  <h3>
                    How it works <ChevronRightIcon />
                  </h3>
                  <p>List. Match. Sail.</p>
                  <p>Whether you're renting or swapping, Mooringmate makes the process simple. List your berth, find the perfect match, complete the payment, and we'll handle all the paperwork and administration.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box className="service-fees-section">
        <Container maxWidth="lg">
          <Grid container spacing={4} style={{ paddingTop: "60px", paddingBottom: "60px" }}>
            <Grid item md={7} sm={12} xs={12}>
              <h6 className="sub-title">Transparent pricing</h6>
              <h2 className="title">Service Fees</h2>
              <p className="service-fees-body">At Mooringmate, we believe in clarity and fairness. We operate on a commission-based model.</p>
              <p className="service-fees-body">For every confirmed booking made through the platform, we charge a 10% service fee.</p>
              <ul className="service-fees-list">
                <li>No listing fees</li>
                <li>No subscription costs</li>
                <li>No hidden charges</li>
              </ul>
              <div className="service-fees-callout">
                <p>You only pay when your berth is successfully booked.</p>
                <p><strong>No cure, no pay.</strong></p>
              </div>
            </Grid>
            <Grid item md={5} sm={12} xs={12}>
              <div className="service-fees-partners-card">
                <h3 className="service-fees-subheading">Professional &amp; Portfolio Partners</h3>
                <p className="service-fees-body">For professional berth operators or partners managing multiple berths, tailored partnership agreements may apply.</p>
                <p className="service-fees-body">If you operate a larger portfolio and are interested in a strategic collaboration, we invite you to contact us directly to discuss a customised structure.</p>
                <hr className="service-fees-divider" />
                <p className="service-fees-goal">Our goal is simple: to create a transparent, efficient and professional marketplace that benefits both berth owners and yacht owners.</p>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box id="faq" className="hideFaq">
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            style={{ paddingTop: "40px", paddingBottom: "80px" }}
            sx={{
              alignItems: "end",
            }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div className="title-section">
                <h2 className="title" style={{ marginBottom: "0px" }}>Frequently Asked Questions</h2>
                <LanguageDropdown
                  languages={languages}
                  defaultLang="en"
                  onLanguageChange={setSelectedLang}
                />
              </div>
              <MooringmateFAQ />
            </Grid>
          </Grid>
        </Container>
      </Box>
      
      {/* <Box>
        <Container maxWidth="lg">
          <Grid
            id="contact"
            container
            spacing={2}
            style={{ paddingTop: "40px", paddingBottom: "80px" }}
            sx={{
              alignItems: "end",
            }}
          >
            <Grid item md={6} sm={12} xs={12}>
              <Grid item md={12}>
                <h6 className="sub-title">Get in touch</h6>
                <h2 className="title">Connect with us for support</h2>
              </Grid>
              <ContactForm />
            </Grid>
            <Grid item md={6} sm={12} xs={12}></Grid>
          </Grid>
        </Container>
      </Box> */}
      <GeneralFooter />
    </Box>
  );
};
